import {lazy} from "react";

export const MonitoringSingleVoyagesLazy = lazy(() => import('./MonitoringSingleVoyages'))